import { EditOutlined, RollbackOutlined } from "@ant-design/icons";
import { Button, Row } from "antd";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { ApiDisaster } from "../../../api/backend/disaster";
import BreakLine from "../../../component/Desktop/breakLine";
import GroupItem from "../../../component/Desktop/groupItem";
import Loading from "../../../component/Desktop/loading/loading";
import RowInput from "../../../component/Desktop/rowInput";
import TitlePage from "../../../component/Desktop/titlePage";
import { lang } from "../../../constants/common.const";
import routerConst from "../../../constants/router.const";
import { handleCatchError } from "../../../constants/utils";
import { getIconByFileType } from "../../../utils/helper";
import rolesConst from "../../../routers/roles/roles.const";
import { useSelector } from "react-redux";

function ViewDisasterCategory() {
  const [showLoading, setShowLoading] = useState(false);
  const [nameCategory, setNameCategory] = useState("Category 1");

  // check role
  const { roles } = useSelector((state) => state.auth);

  const isHeadOfficeAdmin = roles == rolesConst.HEAD_OFFICE_ADMIN;
  const history = useHistory();
  const { id } = useParams();
  const [listAttach, setListAttach] = useState([]);
  const location = useLocation();
  const listData = [
    {
      title: lang.DISASTER_CATEGORY,
      value: nameCategory,
    },
    {
      title: lang.ATTACH,
      value: (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 10,
          }}
        >
          {listAttach.map((attach) => (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 5,
                cursor: "pointer",
              }}
            >
              {getIconByFileType(attach.attachFileName)}
              <a
                target="_blank"
                download={attach.attachFileName}
                href={attach.attachFileUrl}
              >
                {attach.attachFileName}
              </a>
            </div>
          ))}
        </div>
      ),
    },
  ];
  const renderListData = listData.map((item, index) => (
    <div key={index}>
      <BreakLine />
      <RowInput name={item.title} box>
        {item.value}
      </RowInput>
      <BreakLine />
    </div>
  ));
  // Get Detail
  const getDetailCategory = async () => {
    try {
      setShowLoading(true);
      const res = await ApiDisaster.getDetailCategory(id);
      const data = res.data;
      setNameCategory(data.name);
      setListAttach([...data.attachments]);
    } catch (error) {
      handleCatchError(error);
    } finally {
      setShowLoading(false);
    }
  };
  useEffect(() => {
    getDetailCategory();
  }, [id]);
  return (
    <div className="des-content">
      <TitlePage name={lang.DISASTER_CATEGORY_VIEW} />
      <GroupItem center>
        <div className="title-page d-block center mt0 mb0">
          <h1 className="bold white-space">{lang.DISASTER_CATEGORY_VIEW}</h1>
        </div>
        <div className="mt15"></div>
        {renderListData}
        <Row className="mt20" justify="end" gutter={[8, 8]}>
          {isHeadOfficeAdmin && (
            <Button
              className="buttonPC button--info wAuto"
              onClick={() =>
                history.push(
                  `${routerConst.ROUTER_PAGE.DISASTER_CATEGORY[2]}/${id}`
                )
              }
            >
              <EditOutlined />
              {lang.EDIT}
            </Button>
          )}
          <Button
            className="buttonPC button--outline --todo-- wAuto ml15"
            onClick={() => history.goBack()}
          >
            <RollbackOutlined />
            {lang.BACK}
          </Button>
        </Row>
      </GroupItem>
      <Loading show={showLoading} />
    </div>
  );
}

export default ViewDisasterCategory;
